import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from 'react-bootstrap';
import businessSavingsImage from "../../assets/static/business/businesss_banking.png"; // Update with your image path

function BusinessSavingsAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Business Savings Account? We’ve got you covered."
        description="Kontriman offers various ways to support your Business Savings Account – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere."
        imageUrl={FlightImage}
      />

      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={businessSavingsImage}
                  alt="Business Savings Account"
                  className="img-fluid"
                />
              </Col>

              {/* Text column */}
              <Col
                md={6}
                className="d-flex align-items-center order-1 order-md-2"
              >
                <div>
                  <h1 className="custom_heading">
                    Business Savings Account with Kontriman
                  </h1>
                  <p>
                    Secure and grow your business funds with Kontriman’s
                    Business Savings Account. Designed to support SMEs and
                    cooperatives, our account offers competitive interest rates,
                    flexible deposits, and easy access to your money.
                  </p>
                  <p>
                    Benefit from convenient digital banking services,
                    transparent fees, and personalized support tailored to your
                    business needs. Start saving smartly today and build a
                    stronger financial future for your enterprise.
                  </p>
                  <p>
                    <strong>Key Features:</strong>
                  </p>
                  <ul>
                    <li>Attractive interest rates on savings</li>
                    <li>Easy deposit and withdrawal options</li>
                    <li>Access to digital banking and mobile app</li>
                    <li>Dedicated business support and advisory</li>
                    <li>No monthly maintenance fees</li>
                  </ul>

                  <a href="/login">
                    <Button className="custom-button mt-3">
                      Open a Business Savings Account
                    </Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default BusinessSavingsAccount;
